/**
 * BrandyType
 */
export type BrandyType =
  | 'COGNAC'
  | 'ARMAGNAC'
  | 'BRANDY_OR_WINEBRAND'
  | 'OTHER';

export const BrandyType = {
  Cognac: 'COGNAC' as BrandyType,
  Armagnac: 'ARMAGNAC' as BrandyType,
  BrandyOrWinebrand: 'BRANDY_OR_WINEBRAND' as BrandyType,
  Other: 'OTHER' as BrandyType,
};
